import { Injectable, NgZone, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TimeService {
  private ngZone = inject(NgZone);


  private _globalTime: BehaviorSubject<number> = new BehaviorSubject<number>(1)

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() { }

  public get globalTime(): Observable<number>{
    return this._globalTime.asObservable()
  }

  public startTimer(){
    setInterval(()=> this.ngZone.run(()=>this._globalTime.next(1)) , 1000)
  }


}
 